module.exports = __webpack_public_path__ + "img/mp.388b20e0.svg";